namespace advisorop.components.widgets {

    export class NoteListController {
        public notes: Array<domains.INote>;
        public notesDGOptions: DevExpress.ui.dxDataGridOptions;
        public notesDG: DevExpress.ui.dxDataGrid;
        n: number;
        note: domains.INote;
        objectId;
        noteType: domains.NotesType;
        isInEditState: boolean = false;
        dataReturned: domains.INote;
        showDeleted: boolean = false;
        updatingAccountLadda: boolean = false;
        service: any;

        static $inject = ["advisorService", "meetingHubService", "$rootScope"];
        constructor(private advisorService: services.AdvisorService, private meetingHubService: services.MeetingHubService, private $rootScope: ng.IRootScopeService) {

            this.note = {};

            this.notesDGOptions = {
                export: {
                    enabled: true,
                    fileName: "Notes"
                },
                bindingOptions: {
                    dataSource: "vm.notes"
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "No Notes",
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: "dgAlertLogs"
                //},
                columnChooser: {
                    enabled: true,
                    title: "Select columns",
                    //    mode: "select"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'dateCreated', dataType: 'date', caption: 'Note Date', cellTemplate: "colDate", width: 125 },
                    { dataField: 'shortNote', caption: 'Note', showInColumnChooser: false},
                    { dataField: 'fullName', caption: 'Advisor Name', visible: false },
                    { dataField: 'noteStatus', caption: 'Note Status', visible: this.showDeleted, width: 70 },
                    { dataField: 'id', caption: 'Action', cellTemplate: 'colActions', width: 70, showInColumnChooser: false }
                ],
                onInitialized: e => {
                    this.notesDG = e.component;
                },
                masterDetail: {
                    enabled: true,
                    template: "fullNote",
                    autoExpandAll: false
                }
            };
        }


        //Create Note
        createNote(note: domains.INote): void {
            this.note.id = 0;
            this.note.objectId = this.objectId;
            this.updatingAccountLadda = true;
            this.service.createNote(this.note, this.noteType)
                .then((data) => {

                    toastr.success("Note successfully added.");

                    this.note.id = data.data.id;
                    this.isInEditState = false;
                    this.note = {};
                    this.$onInit();

                }).catch((error) => {
                    toastr.error("Error " + error.status + " : " + error.data);
                }).
                finally(() => {
                    this.updatingAccountLadda = false;
                });
        };

        //Update Note
        updateNote(note: domains.INote): void {
            this.updatingAccountLadda = true;

            this.service.updateNote(note, this.noteType)
                .then((data) => {

                    toastr.success("Note has been successfully updated.");

                    this.note.id = data.data.id;
                    this.$onInit();
                })
                .catch((error) => {
                    toastr.error("Error " + error.status + " " + error.data);
                    return;
                })
                .finally(() => {
                    this.updatingAccountLadda = false;
                    this.isInEditState = false;
                    this.note = {};

                });
        };

        getNoteById(noteId: number): void {
            this.isInEditState = true;
            this.service.getNoteById(noteId)
                .success((data) => {
                    this.note = data;
                }).
                error((data, status) => {
                    toastr.error("Can not find this note" + status + " " + data);
                });
        };

        close(): void {
            this.isInEditState = false;
            this.note = {};
            this.$onInit();
        }



        //Delete Note
        deleteNote(note: domains.INote): void {
            if (window.confirm("You want to delete note. Are you sure?")) {
                var x = this.notes;

                this.service.deleteNote(note)
                    .success((data) => {
                        toastr.success("Note deleted.");
                        var ind = x.indexOf(note);
                        if (ind >= 0) {
                            x.splice(ind, 1);
                        }
                        //console.log("Log for delete");
                    })
                    .error((data, status) => {

                        toastr.error("Can not delete this note" + status + " " + data);
                    });
            }

        };

        loadNotes(): void {
            //var width = this.notesDG.columnOption("notes", "width");
            if (this.objectId <= 0) return;

            this.service.getNotes(this.objectId, this.showDeleted, this.noteType)
                .success((data) => {
                    this.notes = data.value;
                    this.notes = this.notes.map((note) => {
                        note.shortNote = note.note.slice(0, 225);
                        if (note.note.length > 225) {
                            note.shortNote += "...";
                        }
                        return note;
                    })
                    this.notesDG.refresh();
                    this.notesDG.repaint();
                    //this.notesDG.columnOption("notes", "visible", width);
                }).error((data, status) => {
                    toastr.error("Note list error: " + status + ":" + data);
                });
        }


        onChangedOptionForDeletedNotes(): void {
            this.showDeleted = this.showDeleted;
            this.notesDG.columnOption("noteStatus", "visible", this.showDeleted);
            //this.notesDG.columnOption("notes", "width", this.showDeleted ? 446 : 539);
            this.loadNotes();
        }


        $onInit() {
            this.loadNotes();
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "noteType") {
                    switch (this.noteType) {
                        case domains.NotesType.INVESTOR:
                            this.service = this.advisorService;
                            break;
                        case domains.NotesType.MEETING:
                            this.service = this.meetingHubService;
                            break;
                        default:
                            this.service = this.advisorService;
                            break;
                    }
                }
            }
        }

        $routerOnActivate(next, previous) {
        }
    }

    class CuNotes implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                objectId: "<",
                noteType: "<"
            };
            this.controller = NoteListController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/cu-notes.html';
        }
    }
    angular.module(Constants.APP).component("cuNotes", new CuNotes());

}